import React from "react";

import { ProductTileModel } from "@api/mappers/products.mapper";

import { ProductSliderSources } from "@utils/enums";

import { ProductSliderContainer } from "@components/Product/ProductSlider/productSlider.container";

type AccessoriesSliderProps = {
    prefetchedData?: Array<ProductTileModel>;
    productSource: ProductSliderSources;
    title: string;
    breakpointsLayoutSettings: string;
};

const RelatedProductsSliderComponent = ({
    prefetchedData,
    productSource,
    title,
    breakpointsLayoutSettings,
}: AccessoriesSliderProps) => {
    return (
        <section className="info-block__content">
            <div className="row">
                <div className="col-12">
                    <div className="relatedProducts-component">
                        <ProductSliderContainer
                            prefetch={true}
                            prefetchedData={prefetchedData}
                            productSource={productSource}
                            amountOfFeatures={0}
                            useInsidePadding={false}
                            showButton={false}
                            showCategoryLink={false}
                            allowInstantAddToCart={false}
                            title={title}
                            breakpointsLayoutSettings={
                                breakpointsLayoutSettings
                            }
                            lazyLoad={false}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};
export { RelatedProductsSliderComponent };
